import { render, staticRenderFns } from "./AmountInputConfig.vue?vue&type=template&id=456dec3f&scoped=true"
import script from "./AmountInputConfig.vue?vue&type=script&lang=js"
export * from "./AmountInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456dec3f",
  null
  
)

export default component.exports